"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "fontWeights", {
    enumerable: true,
    get: function() {
        return fontWeights;
    }
});
const fontWeights = {
    extraBold: 600,
    bold: 500,
    regular: 400
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL3N0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgZm9udFdlaWdodHMgPSB7XG4gIGV4dHJhQm9sZDogNjAwLFxuICBib2xkOiA1MDAsXG4gIHJlZ3VsYXI6IDQwMCxcbn0gYXMgY29uc3Q7XG4iXSwibmFtZXMiOlsiZm9udFdlaWdodHMiLCJleHRyYUJvbGQiLCJib2xkIiwicmVndWxhciJdLCJtYXBwaW5ncyI6Ijs7OzsrQkFBYUE7OztlQUFBQTs7O0FBQU4sTUFBTUEsY0FBYztJQUN6QkMsV0FBVztJQUNYQyxNQUFNO0lBQ05DLFNBQVM7QUFDWCJ9